import React from "react";
import PropTypes from "prop-types";
import FeatherIcon from 'feather-icons-react';

const DynamicTable = ({

  data = [],
  columns = [],
  onTitle,
  onAdd,
  onEdit,
  onDelete,
  onPassCode,
  onDeleteMultiple,
  onHierarchy,
  onSetting,
  onView,
  onApiKey,
  onSubscription,
  search = "",
  onSearchChange,
  actions = true,
}) => {
  const hasData = data && data.length > 0;

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="listjs-table">
              <div className="row g-4 mb-3">
                <div className="col-sm-auto">
                  {
                    onTitle && (
                      <div className="search-box ms-2">
                        {onTitle}
                      </div>
                    )
                  }
                  { onSearchChange && (
                    <div className="search-box ms-2">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search..."
                        value={search}
                        onChange={onSearchChange}
                      />
                      <i className="ri-search-line search-icon" />
                    </div>
                    )}
                </div>
                <div className="col-sm">
                  { onAdd && (
                    <div className="d-flex justify-content-sm-end">
                      <button className="btn btn-success" onClick={onAdd}>
                        <i className="ri-add-line align-bottom me-1" /> Add
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="table-responsive table-card mt-3 mb-1">
                <table className="table align-middle table-nowrap">
                  <thead className="table-light">
                    <tr>
                      <th scope="col" style={{ width: 50 }}>
                        <div className="form-check">
                          *
                        </div>
                      </th>
                      {columns.map((col, idx) => (
                        <th key={idx} className="sort">{col.header}</th>
                      ))}
                      {actions && <th>Actions</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {hasData ? (
                      data.map((item, idx) => (
                        <tr key={idx}>
                          <td>
                            *
                          </td>
                          {columns.map((col, i) => (
                            <td key={i}>
                              {col.render
                                ? col.render(item[col.accessor], item)
                                : item[col.accessor]}
                            </td>
                          ))}
                          {actions && (
                            <td>
                              <div className="d-flex gap-2">
                                {onEdit && (
                                  <button type="button" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit" className="btn btn-ghost-primary btn-icon waves-effect waves-light fs-15"
                                    onClick={() => onEdit(item)}
                                  >
                                    <FeatherIcon icon="edit-3" size="14" color="blue" />
                                  </button>
                                )}
                                {onView && (
                                  <button type="button" data-bs-toggle="tooltip" data-bs-placement="top" title="View Details" className="btn btn-ghost-warning btn-icon waves-effect waves-light fs-15"
                                    onClick={() => onView(item)}
                                  >
                                    <FeatherIcon icon="eye" size="14" color="orange" />
                                  </button>
                                )}
                                {onPassCode && (
                                  <button type="button" data-bs-toggle="tooltip" data-bs-placement="top" title="Passcode"  className="btn btn-ghost-success btn-icon waves-effect waves-light fs-15"
                                    onClick={() => onPassCode(item)}
                                  >
                                    <FeatherIcon icon="log-in" size="14" color="green"  />
                                  </button>

                                )}
                                {onDelete && (
                                  <button type="button"  data-bs-toggle="tooltip" data-bs-placement="top" title="Delete"  className="btn btn-ghost-danger btn-icon waves-effect waves-light fs-15"
                                    onClick={() => onDelete(item)}
                                  >
                                    <FeatherIcon icon="trash-2" size="14" color="red" />
                                  </button>
                                )}
                                {onHierarchy && (
                                  <button type="button"  data-bs-toggle="tooltip" data-bs-placement="top" title="Hierarchy"  className="btn btn-ghost-info btn-icon waves-effect waves-light fs-15"
                                    onClick={() => onHierarchy(item)}
                                  >
                                    <FeatherIcon icon="git-branch"  size="14" color="#ADD8E6" />
                                  </button>
                                )}
                                {onApiKey && (
                                  <button type="button"  data-bs-toggle="tooltip" data-bs-placement="top" title="View Api Key"  className="btn btn-ghost-secondary btn-icon waves-effect waves-light fs-15"
                                    onClick={() => onApiKey(item)}
                                  >
                                    <FeatherIcon icon="key" size="14" color="purple" />
                                  </button>
                                )}
                                {onSetting && (
                                  <button type="button"  data-bs-toggle="tooltip" data-bs-placement="top" title="Settings"  className="btn btn-ghost-warning btn-icon waves-effect waves-light fs-15"
                                    onClick={() => onSetting(item)}
                                  >
                                    <FeatherIcon icon="settings" size="14" color="orange" />
                                  </button>
                                )}
                                {onSubscription && (
                                  <button type="button"  data-bs-toggle="tooltip" data-bs-placement="top" title="Subscription"  className="btn btn-ghost-warning btn-icon waves-effect waves-light fs-15"
                                    onClick={() => onSubscription(item)}
                                  >
                                    <FeatherIcon icon="dollar-sign" size="14" color="green" />
                                  </button>
                                )}
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={columns.length + (actions ? 2 : 1)}>
                          <div className="text-center text-muted">No data found.</div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="d-flex justify-content-end">
                <div className="pagination-wrap hstack gap-2">
                  <button className="page-item pagination-prev disabled">Previous</button>
                  <ul className="pagination listjs-pagination mb-0" />
                  <button className="page-item pagination-next">Next</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
  );
};

DynamicTable.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      accessor: PropTypes.string.isRequired,
      render: PropTypes.func,
    })
  ).isRequired,
  onAdd: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onDeleteMultiple: PropTypes.func,
  onHierarchy : PropTypes.func,
  search: PropTypes.string,
  onSearchChange: PropTypes.func,
  actions: PropTypes.bool,
};

export default DynamicTable;